import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin.js'
gsap.registerPlugin(DrawSVGPlugin)

/**
 * CTA Banner component.
 * @author Dayne Coulson-Hoffacker
 */
export default class CtaBanner {
  /**
   * Constructs a new CtaBanner component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.video = this.element.querySelector('video')
    this.mainHeading = this.element.querySelector('.cta-banner-title')
    this.subHeading = this.element.querySelector('.cta-banner-sub-title')

    var ctaBannerTL = gsap.timeline({
      paused: true,
      onComplete: this.playVideo()
    })

    ctaBannerTL.to(this.element, { duration: 1, autoAlpha: 1, ease: 'power2' })
    ctaBannerTL.to(this.video, { duration: 0.5, autoAlpha: 1, scale: 1, ease: 'power2' }, '<')
    ctaBannerTL.to(this.mainHeading, { duration: 1, autoAlpha: 1, ease: 'power2' }, '<')
    ctaBannerTL.to(this.subHeading, { duration: 1, autoAlpha: 1, ease: 'power2' }, '<')

    ctaBannerTL.play()
  }
  playVideo () {
    this.video.play()
  }
}



// WEBPACK FOOTER //
// ./components/section/cta-banner/index.js